import styles from "./styles.module.scss";
import ModalLayout, { DockPosition } from "components/ModalLayout";
import { useContext, useState } from "react";
import ModalsManagerContext from "contexts/ModalsManager";
import PackagesContext from "contexts/PackagesContext";
import CloseIcon from "assets/icons/close.svg?react";
import { useLocation } from "react-router-dom";
import Input from "components/Input";
import Button from "components/Button";
import fileService from "api/fileService";
import { useTranslation } from "react-i18next";

const EditPDFName = () => {
  const { t } = useTranslation();
  const { modals, setModals } = useContext(ModalsManagerContext);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const PDFId = queryParams.get("pdf");
  const { packages, setPackages } = useContext(PackagesContext);
  const { mutate: updateName, isLoading } = fileService.useUpdateAttachment();

  const [fileName, setFileName] = useState(PDFId.split(":")[1]);

  const closeModal = () => {
    setModals({ ...modals, hide: true });
  };

  const handleSave = () => {
    const copy = [...packages];
    const pack = copy.find((p) => {
      if (!p?.Attachments) return null;
      return p.Attachments.find((a) => a.Uri === PDFId.split(":")[2]);
    });

    const attach = pack.Attachments.find((a) => a.Uri === PDFId.split(":")[2]);
    attach.Label = fileName;

    updateName(
      {
        AttachmentId: attach.Id,
        Label: fileName,
        OwnerId: pack.Id,
        OwnerKind: pack.Kind,
      },
      {
        onSuccess: () => setModals({ ...modals, hide: true }),
      }
    );

    setPackages(copy);
  };

  return (
    <ModalLayout
      dock={DockPosition.DISABLED}
      off={true}
      customX={8}
      customY={0}
      ignore
      isAnimation
      fullHeight={true}
      name="editPDFName"
    >
      <div className={styles.wrapper}>
        <div className={styles.title}>
          {t("documents.editName")}
          <CloseIcon
            onClick={() => {
              closeModal();
            }}
            className={styles.closeIcon}
          />
        </div>
        <div className={styles.content}>
          <Input
            value={fileName}
            onChange={(t) => setFileName(t)}
            label={t("documents.fileName")}
          />
          <div className={styles.button}>
            <Button loading={isLoading} onClick={handleSave} text={t("common.edit")} />
          </div>
        </div>
      </div>
    </ModalLayout>
  );
};

export default EditPDFName;
